import {HttpClient} from '@angular/common/http';
import { Component, OnInit, AfterViewInit, ViewChild, Inject, Input, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, Form } from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { InventarioService } from '../../_services';
import { MatSnackBar} from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {merge, Observable, of as observableOf, Subject}  from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { first } from 'rxjs/operators';
import { EntradaService } from '../../_services';
import { ProductoService } from '../../_services';
import { FulfillmentService } from '../../_services';
import * as XLSX from 'xlsx';
import { AuthenticationService } from '../../_services';
import { AccountService } from 'src/app/_services/account.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-productos',
  templateUrl: './productos.component.html',
  styleUrls: ['./productos.component.scss']
})
export class ProductosComponent implements OnInit {

  edit_item: any = null;
  selected_tab: number = 0;
  label_tab_2: string;
  current_user: any;

  constructor( private authenticationService: AuthenticationService) {
    this.label_tab_2 = "Alta de productos"
    
  }

  ngOnInit() {
    this.asignarDatos();
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue
    
  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);  
  }

  tabClick(event){
    this.selected_tab = event.index;
    if (this.selected_tab != 1){
      this.edit_item = null;
    }
  }

}


@Component({
  selector: 'productos-tab-1',
  templateUrl: './productos-tab-1.html',
  styleUrls: ['./productos.component.scss']

})
export class ProductosTab1 implements AfterViewInit {

  displayedColumns: string[] = [
                                  'ver_detalles',
                                  'shopify_created_at',
                                  'canal', 
                                  'shopify_name',
                                  'stock_disponible',
                                  'bundle',
                                  'cliente', 
                                  'payment_status'
                                ];
  entradaDatabase: EntradaDatabase | null;
  data: EntradaIssue[] = [];

  resultsLength      = 0;
  isLoadingResults   = true;
  isRateLimitReached = false;
  guiaForm           : FormGroup;
  keywords           = "";
  formBO             : FormControl;
  spinner            = false;
  hay_datos          = true; 
  titulo_diff        = false;
  datos_iniciales    = true;
  current_user       : any
  delayTimer         : any;


  constructor(
      private formBuilder: FormBuilder,
      private _httpClient: HttpClient,
      public dialog: MatDialog,
      private inventarioService: InventarioService,
      private productoService: ProductoService,
      private snackBar: MatSnackBar,
      private router: Router,
      private productosComponent: ProductosComponent,
      private authenticationService: AuthenticationService
  ) { }

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  ngAfterViewInit() {


    this.entradaDatabase = new EntradaDatabase(this._httpClient);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    // console.log("las keywords iniciales son " + this.keywords)
    this.hacerTabla(this.keywords);
    this.formBO = new FormControl('', [ ]);


  }

  mostrarCard(){
    if(this.datos_iniciales){
      this.titulo_diff = true;
    }else{
      this.titulo_diff = false;
    }
    this.hay_datos = !this.hay_datos;
  }

  hacerTabla(filtros){
    merge(this.sort.sortChange, this.paginator.page, )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.entradaDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex, this.keywords);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          // console.log("vamos en la 72")
          // console.log(data)
          if(data.items.length == 0) {
            this.hay_datos = false 
            this.datos_iniciales = false
          }else{
            this.hay_datos = true 
            this.datos_iniciales = true
          }
         

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }


  applyFilter(event: Event) {
    clearTimeout(this.delayTimer);
    this.delayTimer = setTimeout(() => {
      const filterValue = (event.target as HTMLInputElement).value;
      this.keywords = filterValue.trim().toLowerCase();
      // console.log("las keywords son ")
      // console.log(this.keywords)
      this.hacerTabla(this.keywords);
    }, 500);
  }

  onChange(value, item_id) {
    this.spinner = true;
    // console.log(value);
    // console.log(item_id);
    this.inventarioService.cambiarBackOrder(item_id, value)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("la data es");
        // console.log(data);
        // console.log(data.status)
        // console.log(data["message"][0]);
        this.spinner = false;
        this.snackBar.open(data["message"][0], "OK", {                      
          duration: 3500,
        });
      },
      error => {
        this.spinner = false;
    });
  }

  openProductosDetalle(item){
    this.productoService.consultarProducto(item.id)
    .pipe(first())
    .subscribe(
      data => {
          if(data.status == 200){
            const dialogProductosDetalle = this.dialog.open(ProductosDetalle ,{ width:'90vw', height: '90%',disableClose: false ,data: {item: data.body.item, files: data.body.files, inventario_scrap: data.body.inventario_scrap} });
          
            //Listener para detectar click en el enditar producto
            const dialogEditSubscription = dialogProductosDetalle.componentInstance.editClicked
            .subscribe(item_id => {
              this.productosComponent.edit_item = item_id;
              this.productosComponent.selected_tab = 1;
              dialogEditSubscription.unsubscribe();
            });
          }
        },
      error => {
    });
  }

  openPublicaciones(item){
    this.productoService.consultarPublicaciones(item.id)
    .pipe(first())
    .subscribe(
      data => {
          if(data.status == 200){
            const dialogProductosDetalle = this.dialog.open(ProductosPublicaciones ,{ width:'90vw', height: '90%',disableClose: false ,data: {publicaciones: data.body.publicaciones, item_master: data.body.item_master} });
          }
        },
      error => {
    });
  }

  surtirBO(item_id){
    this.spinner = true
    this.inventarioService.consultarBO(item_id)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("consultar bo es");
        // console.log(data);
        if(data.status == 200){
          if(data.body["result"] == 200){
            this.surtirBackOrder(item_id);
          }else{
            this.spinner = false;
            this.snackBar.open("No existe ninguna BackOrder que surtir por el momento.", "OK", {                      
              duration: 3500,
            });
          }  
        }
        
      },
      error => {
    });
  }

  surtirBackOrder(item_id){
    this.inventarioService.surtirBO(item_id)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("surtirBO es");
        // console.log(data);
        if(data["result"] == 200){
          this.consultarStatusBO(item_id);
        }
      },
      error => {
    });
  }

  consultarStatusBO(item_id){
    this.inventarioService.consultarStatusBO(item_id)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("surtirBO es");
        // console.log(data);
        if(data.status == 200){
          if(data.body["result"][0] == 200){
            this.spinner = false;
            this.snackBar.open(data.body["result"][1], "OK", {                      
              duration: 3500,
            });
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/inventarios']);
            });
          }else{
            setTimeout(() => 
            {
              this.consultarStatusBO(item_id);
            },3000);
          }
        }
      },
      error => {
    });
  }

  ngOnInit() {
    this.asignarDatos(); 
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue
    
  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);  
  }

}

@Component({
  selector: 'productos-publicaciones',
  templateUrl: './productos-publicaciones.html',
  styleUrls: ['./productos.component.scss']

})

export class ProductosPublicaciones implements OnInit {

  @Output() editClicked = new EventEmitter<any>();

  publicaciones: [];
  item_master: EntradaIssue;
  spinner = false;
  current_user: any;

  constructor(public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private _httpClient: HttpClient,
    private inventarioService: InventarioService,
    private productoService: ProductoService,
    private router: Router,
    private authenticationService: AuthenticationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    if(this.data){
      this.publicaciones = this.data.publicaciones;
      this.item_master = this.data.item_master;
    }
  }

  ngOnInit() {
    this.asignarDatos(); 
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue
    
  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);  
  }

  openDialogEntrada(item_id, seller_sku, titulo){
    // Hacer request para consular el bundle y que responda como
    // render {items => los componentes del bundle que venga (sku, producto, cantidad) }
    // DESCOMENTAR CUANDO ESTE EL REUQEST LISTO
    this.inventarioService.consultarBundle(item_id)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          const dialogRef3 = this.dialog.open(ProductosDialogBundle ,{ width:'90vw', height: '90%',disableClose: false ,data: {params: data, seller_sku: seller_sku, titulo: titulo, item_id: item_id} });
        }
      },
      error => {
    });
  }

}


@Component({
  selector: 'productos-tab-2',
  templateUrl: './productos-tab-2.html',
  styleUrls: ['./productos.component.scss']

})
export class ProductosTab2 implements OnInit {

  @Input() edit_item: any = null;

  formPicture1: FormControl;
  formTitle: FormControl;
  formSku: FormControl;
  formEan: FormControl;
  formMlSku: FormControl;
  formPdfMlSku: FormControl;
  formAmzSku: FormControl;
  formPdfAmzSku: FormControl;
  formLength: FormControl;
  formWidth: FormControl;
  formHeight: FormControl;
  formWeight: FormControl;
  formListPrice: FormControl;
  formAceptaBo: FormControl;
  formClaveSat: FormControl;
  formFraccionArancelaria: FormControl;
  formEtiquetaNom: FormControl;
  formSafetyStock: FormControl;

  breakpoint: number;
  spinner = false;
  text_btn = "Agregar";
  resetear_formulario = false;
  show_alert_title = false;
  error_title = ""

  pdf_ml_sku: any;
  pdf_amz_sku: any;
  etiqueta_nom: any;

  item:any;


  claves_sat: ClaveSat[] = [];

  constructor(
    private accountService: AccountService,
    private productoService: ProductoService,
    private router: Router,
    private snackBar: MatSnackBar,
    private productosComponent: ProductosComponent
    ) { }

  ngOnInit() {
    this.breakpoint = (window.innerWidth <= 599) ? 2 : 8;

    this.formPicture1 = new FormControl('');
    this.formTitle = new FormControl('', [
      Validators.required,
    ]);
    this.formSku = new FormControl('', [
      Validators.required,
    ]);
    this.formEan = new FormControl('', []);
    this.formMlSku = new FormControl('', []);
    this.formPdfMlSku = new FormControl('');
    this.formAmzSku = new FormControl('', []);
    this.formPdfAmzSku = new FormControl('');
    this.formLength = new FormControl('', []);
    this.formWidth = new FormControl('', []);
    this.formHeight = new FormControl('', []);
    this.formWeight = new FormControl('', []);
    this.formListPrice = new FormControl('', [
      Validators.required,
    ]);
    this.formAceptaBo = new FormControl('', [
      Validators.required,
    ]);
    this.formClaveSat = new FormControl('');
    this.formFraccionArancelaria = new FormControl('', []);
    this.formEtiquetaNom = new FormControl('');
    this.formSafetyStock = new FormControl('',[]);
  
    this.resetear_formulario = true;

  }

  ngOnChanges(changes: SimpleChanges){
    let idioma = localStorage.getItem('idioma');
    if ( (changes.edit_item.previousValue != changes.edit_item.currentValue) && (this.edit_item != null) ){
      this.text_btn = 'Actualizar';
      var titulo = 'Actualizar producto';
      if(idioma == 'en'){
        titulo = 'Update product';
        this.text_btn = 'Update';
      }
      setTimeout(() => {
        this.productosComponent.label_tab_2 = titulo;
      }, 500);
      this.consultarProductosDetalle(this.edit_item);
    }else{
      this.text_btn = 'Agregar';
      var titulo = 'Alta de productos';
      if(idioma == 'en'){
        titulo = 'Product registration';
        this.text_btn = 'Add';
      }
      setTimeout(() => {
        this.productosComponent.label_tab_2 = titulo;
      }, 500);
      if(this.resetear_formulario){
        this.resetearFormulario();
      }
    }
  }

  onResize(event) {
    this.breakpoint = (window.innerWidth <= 599) ? 2 : 8;
  }

  validarDatos(){
    if(this.formTitle.invalid || this.formSku.invalid || this.formListPrice.invalid || this.formAceptaBo.invalid 
      || this.formClaveSat.invalid){
      return;
    }else{

      var elItem = this.formClaveSat.value;
      if(elItem){
        if(!(typeof elItem === 'object' && elItem !== null)){
          this.snackBar.open("Debes seleccionar una Clave SAT de la lista", "OK", {                      
            duration: 5000,
          });
          return;
        }
      }
      
      if (this.edit_item == null){
        this.crearProducto();
      }else{
        this.actualizarProducto();
      }
    }
  }

  displayFn(subject){
    if(subject){
      return subject.clave_prod_serv + " - " + subject.descripcion;
    }else{
      return undefined;
    }
  }

  cargarClavesSat(){

    this.accountService.consultarClavesSat(this.formClaveSat.value)
    .pipe(first())
    .subscribe(
      data => {
          if(data.status == 200){
            this.claves_sat = data.body.claves_sat;
          }
        },
      error => {
    });
  }

  crearProducto(){
    this.spinner = true;
    const sku = this.formSku.value ? this.formSku.value.trim() : this.formSku.value;
    const ean = this.formEan.value ? this.formEan.value.trim() : this.formEan.value;
      this.productoService.crearProducto(this.formTitle.value, sku, ean, this.formMlSku.value, this.pdf_ml_sku, this.formAmzSku.value, this.pdf_amz_sku, this.formLength.value, this.formWidth.value, this.formHeight.value, this.formWeight.value, this.formListPrice.value, this.formAceptaBo.value, this.formClaveSat.value.clave_prod_serv, this.formFraccionArancelaria.value, this.etiqueta_nom, this.formSafetyStock.value)
      .pipe(first())
      .subscribe(
        data => {
          // console.log("la data es");
          // console.log(data);
          // console.log("status es "+data["status"])
          if (data["status"] == 200){
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/productos']);
            });
          }
          this.snackBar.open(data["message"], "OK", {                      
            duration: 7500,
          });
         this.spinner = false;
        },
        error => {
          this.spinner = false;
          this.snackBar.open("Hubo un error al crear el producto", "OK", {                      
            duration: 7500,
          });
     });
  }

  actualizarProducto(){
    this.spinner = true;
      this.productoService.actualizarProducto(this.edit_item, this.formTitle.value, this.formSku.value, this.formEan.value, this.formMlSku.value, this.pdf_ml_sku, this.formAmzSku.value, this.pdf_amz_sku, this.formLength.value, this.formWidth.value, this.formHeight.value, this.formWeight.value, this.formListPrice.value, this.formAceptaBo.value, this.formClaveSat.value.clave_prod_serv, this.formFraccionArancelaria.value, this.etiqueta_nom, this.formSafetyStock.value)
      .pipe(first())
      .subscribe(
        data => {
          // console.log("la data es");
          // console.log(data);
          // console.log("status es "+data["status"])
          if (data["status"] == 200){
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/productos']);
            });
          }
          this.snackBar.open(data["message"], "OK", {                      
            duration: 7500,
          });
         this.spinner = false;
        },
        error => {
          this.spinner = false;
          this.snackBar.open("Hubo un error al actualizar el producto", "OK", {                      
            duration: 7500,
          });
     });
  }

  consultarProductosDetalle(item_id){
    this.item = null;
    this.productoService.consultarProducto(item_id)
    .pipe(first())
    .subscribe(
      data => {
          if(data.status == 200){
            this.item = data.body.item;

            this.formTitle.setValue(this.item.title);
            this.formSku.setValue(this.item.seller_sku);
            this.formEan.setValue(this.item.ean);
            this.formMlSku.setValue(this.item.ml_sku);
            this.formAmzSku.setValue(this.item.amz_sku);
            this.formLength.setValue(this.item.length);
            this.formWidth.setValue(this.item.width);
            this.formHeight.setValue(this.item.height);
            this.formWeight.setValue(this.item.weight);
            this.formListPrice.setValue(this.item.list_price);
            this.formAceptaBo.setValue(String(this.item.acepta_bo));
            this.formFraccionArancelaria.setValue(this.item.fraccion_arancelaria);
            this.formSafetyStock.setValue(this.item.safety_stock);

            this.accountService.consultarClaveSat(this.item.clave_sat)
            .pipe(first())
            .subscribe(
              data => {
                  if(data.status == 200){
                    if (data.body.message == 'OK'){
                      this.formClaveSat.setValue(data.body.clave_sat);
                    }
                  }
                },
              error => {
            });

          }
        },
      error => {
    });
  }

  resetearFormulario(){
    this.formTitle.setValue('');
    this.formSku.setValue('');
    this.formEan.setValue('');
    this.formMlSku.setValue('');
    this.formAmzSku.setValue('');
    this.formLength.setValue('');
    this.formWidth.setValue('');
    this.formHeight.setValue('');
    this.formWeight.setValue('');
    this.formListPrice.setValue('');
    this.formAceptaBo.setValue('');
    this.formClaveSat.setValue('');
    this.formFraccionArancelaria.setValue('');
    this.formSafetyStock.setValue('');
  }

  handleFileInputPdfMlSku(files: FileList) {
    this.pdf_ml_sku = files.item(0);
  }

  handleFileInputPdfAmzSku(files: FileList) {
    this.pdf_amz_sku = files.item(0);
  }

  handleFileInputEtiquetaNom(files: FileList) {
    this.etiqueta_nom = files.item(0);
  }

  show_alert(event: Event) {
    this.show_alert_title = false;
    this.error_title = "";
    if(this.item != null){
      const filterValue = (event.target as HTMLInputElement).value;
      let title = filterValue.trim();
      let ventiapp_id = this.item.ventiapp_id;
      let shopify_product_id = this.item.shopify_product_id;
      let title_item = this.item.title;

      if(title_item.includes('vvvv-')){
        if(shopify_product_id != null && shopify_product_id != '' && shopify_product_id != ' '){
          if(title.includes('vvvv-')){
            const array = title.split("vvvv-");
            if(array[1].trim().length != 0 && array[1] != '' && array[1] != ' ' && array[1] != null){
              this.show_alert_title = false;
            }else{
              this.error_title = 'El título del producto no contiene la estructura solicitada, debe contener algo después de: vvvv-';
              this.show_alert_title = true;
            }
          }else{
            this.error_title = 'El título del producto no contiene la estructura solicitada, debe contener: vvvv-';
            this.show_alert_title = true;
          } 
        }else if(ventiapp_id != null && ventiapp_id != '' && ventiapp_id != ' '){
          if(title.includes('vvvv-')){
            const array = title.split("vvvv-");
            if(array[1].trim().length != 0 && array[1] != '' && array[1] != ' ' && array[1] != null){
  
              var arr_datos_var = [];
              if(array[1].includes(', ')){
                arr_datos_var = array[1].split(", ");
              }else{
                arr_datos_var.push(array[1]);
              }
              
              if(arr_datos_var.length > 0){
                for (var i=0; i< arr_datos_var.length; i++) {
                  if(arr_datos_var[i].includes(' - ')){
                    var arr_atr = arr_datos_var[i].split(' - ');
                    if(arr_atr[0].trim().length != 0 && arr_atr[1].trim().length != 0){
                      this.show_alert_title = false;
                    }else{
                      this.error_title = 'El título del producto no contiene la estructura solicitada para Ventiapp, el atributo y valor no pueden estar vacíos';
                      this.show_alert_title = true;
                      break;
                    }
                  }else{
                    this.error_title = 'El título del producto no contiene la estructura solicitada para Ventiapp, el atributo y valor deben estar separados por:  - ';
                    this.show_alert_title = true;
                    break;
                  }
                }
              }else{
                this.error_title = 'El título del producto no contiene la estructura solicitada para una variante de Ventiapp, debe contener algo después de: vvvv-';
                this.show_alert_title = true;
              }
  
            }else{
              this.error_title = 'El título del producto no contiene la estructura solicitada para una variante de Ventiapp, debe contener algo después de: vvvv-';
              this.show_alert_title = true;
            }
          }else{
            this.error_title = 'El título del producto no contiene la estructura solicitada para una variante de Ventiapp, debe contener: vvvv-';
            this.show_alert_title = true;
          }      
        }
      }

    }
  }

}

@Component({
  selector: 'productos-tab-3',
  templateUrl: './productos-tab-3.html',
  styleUrls: ['./productos.component.scss']

})
export class ProductosTab3 implements OnInit {

  isLinear = false;
  firstFormGroup: FormGroup;
  progress = false;
  descargar = false;
  url_descargar = "";
  formFile: FormControl;
  file_name: string;
  fileToUpload: File = null;
  exito = false;
  enviado = true;
  spinner = false;
  isExcelFile: boolean;
  keys: string[];
  dataSheet = new Subject();
  boxes:any;
  show_error_table = false;
  show_enviar_formato = false;
  error_data = [];
  displayedColumns: string[] = ['no_fila_excel', 'mensaje'];

  constructor(private _formBuilder: FormBuilder,
    private fulfillmentService: FulfillmentService,
    private productoService: ProductoService,
    private snackBar: MatSnackBar,
    private router: Router,
    public dialog: MatDialog
    ) {}

  ngOnInit() {
    this.traer_boxes();
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.formFile = new FormControl('', Validators.required);
    this.productoService.consultarPlantilla()
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          if(data.body["result"] == 200){
            this.url_descargar = data.body["url_descargar"];
            this.progress = false;
            this.descargar = true;
          }
        }
      },
      error => {
    });
  }

  handleFileInput(files) {
    this.show_error_table = false;
    this.show_enviar_formato = false;
    this.error_data = [];
    
    this.fileToUpload = files.target.files.item(0);
    if (this.fileToUpload == null){
      return false;
    }
    this.spinner = true;
    this.fulfillmentService.getUploadURlXlsx(this.fileToUpload.type)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.subirAWS(data.body["data"], this.fileToUpload);
          this.validar_xlsx(files);
        }else{
          
        }
      },
      error => {
    });
  }

  subirAWS(response, fileToUpload){
    this.file_name = response.file_name
    this.fulfillmentService.subirArchivoXLS(response.url, fileToUpload)
    .pipe(first())
    .subscribe(
      data => {
        this.enviado = false;
        this.spinner = false;
      },
      error => {
    });
  }

  async validar_xlsx(evt){
    let rows, header;
    const target: DataTransfer = <DataTransfer>(evt.target);
    this.isExcelFile = !!target.files[0].name.match(/(.xls|.xlsx)/);
    if (target.files.length > 1) {
      this.formFile.setValue(null);
    }
    if (this.isExcelFile) {
      this.spinner = true;
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /* save data */
        rows = XLSX.utils.sheet_to_json(ws, {header:1});
        rows.shift(); // Elimina primera fila (fil del encabezado)
        let lista_errores = [];
        let x = 2;
        for(let row of rows){
          if(row.length > 0){
            let errores = [];
            errores.push(x);
            let titulo = row[0]; // Obligatorio
            if (!this.validar_obligatorio(titulo)){
                errores.push("El título es obligatorio");
            }
            let foto = row[1]; // Debe ser dirección web y .png o .jpg
            if (!this.isValidUrl(foto)){
                errores.push(`La Foto:  ${foto}  no tiene un formato URL válido`);
            }else{
                if (!this.validar_extension_archivo(foto, [".png", ".jpg" , ".jpeg"])){
                    errores.push(`La Foto:  ${foto}  debe tener la extensión .png, .jpg o .jpeg  `);
                }
            }
            let seller_sku = row[2]; // Obligatorio
            if (!this.validar_obligatorio(seller_sku)){
                errores.push("El SKU es obligatorio");
            }
            let ean = row[3];
            let ml_sku = row[4];
            let pdf_ml_sku = row[5]; // Debe ser dirección web y .pdf
            if (!this.isValidUrl(pdf_ml_sku)){
                errores.push(`El PDF ML SKU:  ${pdf_ml_sku}  no tiene un formato URL válido`);
            }else{
                if (!this.validar_extension_archivo(pdf_ml_sku, [".pdf"])){
                    errores.push(`El PDF ML SKU:  ${pdf_ml_sku}  debe tener la extensión .pdf`);
                }
            }
            let amz_sku = row[6];
            let pdf_amz_sku = row[7]; // Debe ser dirección web y .pdf
            if (!this.isValidUrl(pdf_amz_sku)){
                errores.push(`El PDF AMZ SKU:  ${pdf_amz_sku}  no tiene un formato URL válido`);
            }else{
                if (!this.validar_extension_archivo(pdf_amz_sku, [".pdf"])){
                    errores.push(`El PDF AMZ SKU:  ${pdf_amz_sku}  debe tener la extensión .pdf`);
                }
            }
            let largo = row[8]; // Numérico
            if (!this.es_numerico(largo)){
                errores.push(`El Largo:  ${largo}  es incorrecto. Debe ser numérico y sin espacios`);
            }
            let ancho = row[9]; // Numérico
            if (!this.es_numerico(ancho)){
                errores.push(`El Ancho:  ${ancho}  es incorrecto. Debe ser numérico y sin espacios`);
            }
            let alto = row[10]; // Numérico
            if (!this.es_numerico(alto)){
                errores.push(`El alto:  ${alto}  es incorrecto. Debe ser numérico y sin espacios`);
            }
            let peso = row[11]; // Numérico
            if (!this.es_numerico(peso)){
                errores.push(`El peso:  ${peso}  es incorrecto. Debe ser numérico y sin espacios`);
            }
            let precio = row[12]; // Numérico
            if (!this.validar_obligatorio(precio)){
                errores.push("El precio es obligatorio");
            }
            if (!this.es_numerico(precio)){
                errores.push(`El precio:  ${precio}  es incorrecto. Debe ser numérico y sin espacios`);
            }
            let acepta_bo = row[13]; // Si, No
            let array_acepta_bo = ["si","no"];
            if (!this.validar_dato(acepta_bo, array_acepta_bo)){
                errores.push(`El acepta_bo:  ${acepta_bo}  debe ser Si o No`);
            }
            let estado_producto = row[14]; //Activo, Pausado
            let array_estado_producto = ["activo", "pausado"];
            if (!this.validar_dato(estado_producto, array_estado_producto)){
                errores.push(`El Estado del producto:  ${estado_producto}  debe ser Activo o Pausado`);
            }
            let clave_sat = row[15]; // Obligatorio
            if (!this.validar_obligatorio(clave_sat)){
                errores.push("La Clave SAT es obligatorio");
            }
            let fraccion_arancelaria = row[16];
            let etiqueta_nom = row[17]; // Debe ser dirección web y .pdf
            if (!this.isValidUrl(etiqueta_nom)){
                errores.push(`La etiqueta NOM:  ${etiqueta_nom}  no tiene un formato URL válido`);
            }else{
                if (!this.validar_extension_archivo(etiqueta_nom, [".pdf"])){
                    errores.push(`La etiqueta NOM:  ${etiqueta_nom}  debe tener la extensión .pdf`);
                }
            }

            let safety_stock = row[18]; // Numérico
            // if (!this.validar_obligatorio(safety_stock)){
            //     errores.push("El Inventario de Seguridad es Obligatorio");
            // }
            if (!this.es_numerico(safety_stock)){
                errores.push(`El Inventario de Seguridad:  ${safety_stock}  es incorrecto. Debe ser numérico y sin espacios`);
            }

            if (errores.length > 1){
                lista_errores.push(errores);
            }
          }
          x++;
        }

        if (lista_errores.length > 0){
          this.formFile.setValue(null);
          this.render_error_table(lista_errores);
          this.snackBar.open("Hay registros con errores en el formato de excel", "OK", {                      
            duration: 3500,
          });
        }else{
          this.show_enviar_formato = true;
          this.formFile.disable();
        }

      }

      reader.readAsBinaryString(target.files[0]);
    } else {
      this.formFile.setValue(null);
    }
  }

  traer_boxes() {
    return this.productoService.consultarBoxes()
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          if(data.body["result"][0] == 200){
            this.boxes = data.body["result"][1];
            this.boxes = this.boxes.map(function(x) { // Convertimos elementos del arreglo a minúsculas
              return x.nombre.toLowerCase();
            });
          }else{
            this.boxes = [];
          }
        }
      },
      error => {
    });
  }

  validar_obligatorio(value) {

    if(value == undefined){
        return false;
    }else{
        value = value.toString().replace(/\s+/g, ''); 
        if (value == ""){
            return false;
        }
    }
    return true;
  }

  isValidUrl(value) {
    if(value != undefined){
        value = value.toString().replace(/\s+/g, ''); // Eliminamos espacios
        if (value != ""){
            try {
                new URL(value);
            } catch (_) {
                return false;  
            }
        }
    }
    return true;    
  }

  validar_extension_archivo(value, extensiones) {
    let salida = false;
    if(value != undefined){
        value = value.toString().replace(/\s+/g, ''); // Eliminamos espacios
        if (value != ""){
            for (let extension of extensiones){
                let split_data = value.split(extension);
                if (split_data.length > 1){
                    salida = true;
                }
            }
        }else{
            salida = true;
        }
    }else{
        salida = true;
    }
    return salida;
  }

  es_numerico(value) {
    if (value != undefined){
        value = value.toString().replace(/\s+/g, ''); 
        var valoresAceptados = /^[0-9]*(\.?)[0-9]+$/;
        if(value.match(valoresAceptados)){
            return true;
        }else{
            return false;
        }
    }
    return true;
  }

  validar_dato(value, array_values) {
    if(value != undefined){
        value = value.toString().replace(/\s+/g, ''); // Eliminamos espacios
        if (value == ""){
            return true;
        }
        array_values = array_values.map(function(x) { // Convertimos elementos del arreglo a minúsculas
            return x.toString().toLowerCase().replace(/\s+/g, '');
        });
        let validation_result = array_values.includes(value.toLowerCase());
        if (!validation_result){
            return false;
        }
    }
    return true;
  }

  render_error_table(lista_errores){
    for (let errores of lista_errores){
      let x = 0;
      let mensaje = "";
      let no_fila_excel = errores[0];
      for (let error of errores){
        if (x > 0){
            if (x == 1){
              mensaje = `${error}`;
            }else{
              mensaje = `${mensaje} |-| ${error}`;
            }
        }
        x++;
      }
      let row = {no_fila_excel: no_fila_excel, mensaje: mensaje}
      this.error_data.push(row);
    }

    
    this.show_error_table = true;
  }

  enviarEntradaMasiva(){
    this.enviado = true;
    if(this.formFile.invalid){
      this.snackBar.open("Debes anexar el formato primero.", "OK", {                      
        duration: 3500,
      });
    }else{
      this.spinner = true;
      this.productoService.mandarEntrada(this.file_name)
      .pipe(first())
      .subscribe(
        data => {
          if(data.status == 200){
            this.consultarStatusMasivo();
          }
        },
        error => {
      });
    }
  }

  consultarStatusMasivo(){
    this.productoService.consultarMasivo()
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          if(data.body["result"] == 200){
            this.snackBar.open("Productos Registrados Correctamente", "OK", {                      
              duration: 3500,
            });
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/productos']);
            });
          }else{
            setTimeout(() => 
            {
              this.consultarStatusMasivo();
            },3000);
          }
        }
      },
      error => {
    });
  }

}

@Component({
  selector: 'productos-tab-4',
  templateUrl: './productos-tab-4.html',
  styleUrls: ['./productos.component.scss']

})
export class ProductosTab4 implements OnInit {

  isLinear = false;
  firstFormGroup: FormGroup;
  progress = false;
  descargar = false;
  url_descargar = "";
  formFile: FormControl;
  file_name: string;
  fileToUpload: File = null;
  exito = false;
  enviado = true;
  spinner = false;
  isExcelFile: boolean;
  keys: string[];
  dataSheet = new Subject();
  boxes:any;
  show_error_table = false;
  show_enviar_formato = false;
  error_data = [];
  displayedColumns: string[] = ['no_fila_excel', 'mensaje'];
  productos_pausados = false;
  productos_en_ceros = false;
  show_descargar_plantilla = false;

  constructor(private _formBuilder: FormBuilder,
    private fulfillmentService: FulfillmentService,
    private productoService: ProductoService,
    private snackBar: MatSnackBar,
    private router: Router,
    public dialog: MatDialog
    ) {}

  ngOnInit() {
    this.traer_boxes();
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.formFile = new FormControl('', Validators.required);
    
  }

  generarPlantilla(){
    this.spinner = true;
    this.productoService.generarPlantilla(this.productos_pausados, this.productos_en_ceros)
    .pipe(first())
    .subscribe(
      data => {
        console.log(data.result);
        //if(data.status == 200){
          if(data.result == 200){
            this.progress = false;
            this.descargar = true;
            this.consultarStatusPlantilla();
          }else{
            alert("Ocurrio un error");
          }
        //}
      },
      error => {
    });
  }

  habilitarBtnGenerarPlantilla(){
    this.descargar = false;
    this.show_descargar_plantilla = false;
    this.url_descargar = null;
    this.show_error_table = false;
    this.error_data = [];
    this.show_enviar_formato = false;
    this.formFile.setValue(null);
    this.formFile.enable();
  }
  

  consultarStatusPlantilla(){
    this.productoService.consultarInformeGenerarPlantilla()
    .pipe(first())
    .subscribe(
      data => {
        console.log(data);
        if(data.status == 200){
          if(data.body["result"][0] == 200){
            this.url_descargar = data.body["result"][1];
            this.show_descargar_plantilla = true;
            this.snackBar.open("La plantilla se generó correctamente", "OK", {                      
              duration: 3500,
            });
            this.spinner = false;
          }else{
            setTimeout(() => 
            {
              this.consultarStatusPlantilla();
            },3000);
          }
        }
      },
      error => {
    });
  }

  handleFileInput(files) {
    this.show_error_table = false;
    this.show_enviar_formato = false;
    this.error_data = [];
    
    this.fileToUpload = files.target.files.item(0);
    if (this.fileToUpload == null){
      return false;
    }
    this.spinner = true;
    this.fulfillmentService.getUploadURlXlsx(this.fileToUpload.type)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.subirAWS(data.body["data"], this.fileToUpload);
          this.validar_xlsx(files);
        }else{
          
        }
      },
      error => {
    });
  }

  subirAWS(response, fileToUpload){
    this.file_name = response.file_name
    this.fulfillmentService.subirArchivoXLS(response.url, fileToUpload)
    .pipe(first())
    .subscribe(
      data => {
        this.enviado = false;
        this.spinner = false;
      },
      error => {
    });
  }

  async validar_xlsx(evt){
    let rows, header;
    const target: DataTransfer = <DataTransfer>(evt.target);
    this.isExcelFile = !!target.files[0].name.match(/(.xls|.xlsx)/);
    if (target.files.length > 1) {
      this.formFile.setValue(null);
    }
    if (this.isExcelFile) {
      this.spinner = true;
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /* save data */
        rows = XLSX.utils.sheet_to_json(ws, {header:1});
        rows.shift(); // Elimina primera fila (fil del encabezado)
        let lista_errores = [];
        let x = 2;
        for(let row of rows){
          if(row.length > 0){
            let errores = [];
            errores.push(x);
            let item_id = row[0];
            if (!this.validar_obligatorio(item_id)){
              errores.push("El item_id es obligatorio");
            }else{
                if (!this.es_numerico(item_id)){
                    errores.push(`El item_id: <strong> ${item_id} </strong> es incorrecto. Debe ser numérico y sin espacios`);
                }
            }
            let titulo = row[1]; // Obligatorio
            if (!this.validar_obligatorio(titulo)){
                errores.push("El título es obligatorio");
            }
            let foto = row[2]; // Debe ser dirección web y .png o .jpg
            if (!this.isValidUrl(foto)){
                errores.push(`La Foto:  ${foto}  no tiene un formato URL válido`);
            }else{
                if (!this.validar_extension_archivo(foto, [".png", ".jpg", ".jpeg"])){
                    errores.push(`La Foto:  ${foto}  debe tener la extensión .png, .jpg o .jpeg`);
                }
            }
            let seller_sku = row[3]; // Obligatorio
            if (!this.validar_obligatorio(seller_sku)){
                errores.push("El SKU es obligatorio");
            }
            let ean = row[4];
            let ml_sku = row[5];
            let pdf_ml_sku = row[6]; // Debe ser dirección web y .pdf
            if (!this.isValidUrl(pdf_ml_sku)){
                errores.push(`El PDF ML SKU:  ${pdf_ml_sku}  no tiene un formato URL válido`);
            }else{
                if (!this.validar_extension_archivo(pdf_ml_sku, [".pdf"])){
                    errores.push(`El PDF ML SKU:  ${pdf_ml_sku}  debe tener la extensión .pdf`);
                }
            }
            let amz_sku = row[7];
            let pdf_amz_sku = row[8]; // Debe ser dirección web y .pdf
            if (!this.isValidUrl(pdf_amz_sku)){
                errores.push(`El PDF AMZ SKU:  ${pdf_amz_sku}  no tiene un formato URL válido`);
            }else{
                if (!this.validar_extension_archivo(pdf_amz_sku, [".pdf"])){
                    errores.push(`El PDF AMZ SKU:  ${pdf_amz_sku}  debe tener la extensión .pdf`);
                }
            }
            let largo = row[9]; // Numérico
            if (!this.es_numerico(largo)){
                errores.push(`El Largo:  ${largo}  es incorrecto. Debe ser numérico y sin espacios`);
            }
            let ancho = row[10]; // Numérico
            if (!this.es_numerico(ancho)){
                errores.push(`El Ancho:  ${ancho}  es incorrecto. Debe ser numérico y sin espacios`);
            }
            let alto = row[11]; // Numérico
            if (!this.es_numerico(alto)){
                errores.push(`El alto:  ${alto}  es incorrecto. Debe ser numérico y sin espacios`);
            }
            let peso = row[12]; // Numérico
            if (!this.es_numerico(peso)){
                errores.push(`El peso:  ${peso}  es incorrecto. Debe ser numérico y sin espacios`);
            }
            let precio = row[13]; // Numérico
            if (!this.validar_obligatorio(precio)){
              errores.push("El precio es obligatorio");
            }else{
              if (!this.es_numerico(precio)){
                  errores.push(`El precio:  ${precio}  es incorrecto. Debe ser numérico y sin espacios`);
              }
            }
            let acepta_bo = row[14]; // Si, No
            let array_acepta_bo = ["si","no"];
            if (!this.validar_dato(acepta_bo, array_acepta_bo)){
                errores.push(`El acepta_bo:  ${acepta_bo}  debe ser Si o No`);
            }
            let estado_producto = row[15]; //Activo, Pausado
            let array_estado_producto = ["activo", "pausado"];
            if (!this.validar_dato(estado_producto, array_estado_producto)){
                errores.push(`El Estado del producto:  ${estado_producto}  debe ser Activo o Pausado`);
            }
            let clave_sat = row[16]; // Obligatorio
            if (!this.validar_obligatorio(clave_sat)){
                errores.push("La Clave SAT es obligatorio");
            }
            let fraccion_arancelaria = row[17];
            let etiqueta_nom = row[18]; // Debe ser dirección web y .pdf
            if (!this.isValidUrl(etiqueta_nom)){
                errores.push(`La etiqueta NOM:  ${etiqueta_nom}  no tiene un formato URL válido`);
            }else{
                if (!this.validar_extension_archivo(etiqueta_nom, [".pdf"])){
                    errores.push(`La etiqueta NOM:  ${etiqueta_nom}  debe tener la extensión .pdf`);
                }
            }

            let safety_stock = row[19]; // Numérico
            // if (!this.validar_obligatorio(safety_stock)){
            //     errores.push("El Inventario de Seguridad es Obligatorio");
            // }
            if (!this.es_numerico(safety_stock)){
                errores.push(`El Inventario de Seguridad:  ${safety_stock}  es incorrecto. Debe ser numérico y sin espacios`);
            }

            if (errores.length > 1){
                lista_errores.push(errores);
            }
          }
          x++;
        }

        if (lista_errores.length > 0){
          this.formFile.setValue(null);
          this.render_error_table(lista_errores);
          this.snackBar.open("Hay registros con errores en el formato de excel", "OK", {                      
            duration: 3500,
          });
        }else{
          this.show_enviar_formato = true;
          this.formFile.disable();
        }

      }

      reader.readAsBinaryString(target.files[0]);
    } else {
      this.formFile.setValue(null);
    }
  }

  traer_boxes() {
    return this.productoService.consultarBoxes()
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          if(data.body["result"][0] == 200){
            this.boxes = data.body["result"][1];
            this.boxes = this.boxes.map(function(x) { // Convertimos elementos del arreglo a minúsculas
              return x.nombre.toLowerCase();
            });
          }else{
            this.boxes = [];
          }
        }
      },
      error => {
    });
  }

  validar_obligatorio(value) {

    if(value == undefined){
        return false;
    }else{
        value = value.toString().replace(/\s+/g, ''); 
        if (value == ""){
            return false;
        }
    }
    return true;
  }

  isValidUrl(value) {
    if(value != undefined){
        value = value.toString().replace(/\s+/g, ''); // Eliminamos espacios
        if (value != ""){
            try {
                new URL(value);
            } catch (_) {
                return false;  
            }
        }
    }
    return true;    
  }

  validar_extension_archivo(value, extensiones) {
    let salida = false;
    if(value != undefined){
        value = value.toString().replace(/\s+/g, ''); // Eliminamos espacios
        if (value != ""){
            for (let extension of extensiones){
                let split_data = value.split(extension);
                if (split_data.length > 1){
                    salida = true;
                }
            }
        }else{
            salida = true;
        }
    }else{
        salida = true;
    }
    return salida;
  }

  es_numerico(value) {
    if (value != undefined){
        value = value.toString().replace(/\s+/g, ''); 
        var valoresAceptados = /^[0-9]*(\.?)[0-9]+$/;
        if(value.match(valoresAceptados)){
            return true;
        }else{
            return false;
        }
    }
    return true;
  }

  validar_dato(value, array_values) {
    if(value != undefined){
        value = value.toString().replace(/\s+/g, ''); // Eliminamos espacios
        if (value == ""){
            return true;
        }
        array_values = array_values.map(function(x) { // Convertimos elementos del arreglo a minúsculas
            return x.toString().toLowerCase().replace(/\s+/g, '');
        });
        let validation_result = array_values.includes(value.toLowerCase());
        if (!validation_result){
            return false;
        }
    }
    return true;
  }

  render_error_table(lista_errores){
    for (let errores of lista_errores){
      let x = 0;
      let mensaje = "";
      let no_fila_excel = errores[0];
      for (let error of errores){
        if (x > 0){
            if (x == 1){
              mensaje = `${error}`;
            }else{
              mensaje = `${mensaje} |-| ${error}`;
            }
        }
        x++;
      }
      let row = {no_fila_excel: no_fila_excel, mensaje: mensaje}
      this.error_data.push(row);
    }

    
    this.show_error_table = true;
  }

  enviarEdicionMasiva(){
    this.enviado = true;
    if(this.formFile.invalid){
      this.snackBar.open("Debes anexar el formato primero.", "OK", {                      
        duration: 3500,
      });
    }else{
      this.spinner = true;
      this.productoService.mandarEdicionMasiva(this.file_name)
      .pipe(first())
      .subscribe(
        data => {
          if(data.status == 200){
            this.consultarStatusEdicionMasivo();
          }
        },
        error => {
      });
    }
  }

  consultarStatusEdicionMasivo(){
    this.productoService.consultarEdicionMasivo()
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          if(data.body["result"] == 200){
            this.snackBar.open("Productos Actualizados Correctamente", "OK", {                      
              duration: 3500,
            });
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/productos']);
            });
          }else{
            setTimeout(() => 
            {
              this.consultarStatusEdicionMasivo();
            },3000);
          }
        }
      },
      error => {
    });
  }

}


@Component({
  selector: 'productos-dialog-bundle',
  templateUrl: './productos-dialog-bundle.html',
  styleUrls: ['./productos.component.scss']

})

export class ProductosDialogBundle implements OnInit {

  params: any;
  item_bundle: any;

  constructor(public dialog: MatDialog,
  private snackBar: MatSnackBar,
  private _httpClient: HttpClient,
  public dialogRef: MatDialogRef<ProductosDialogBundle>,
   private inventarioService: InventarioService,
  @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    if(this.data.item_id){
      // console.log("la data es")
      // console.log(this.data)
      this.item_bundle = this.data.item_id;
      // console.log("Params son")
      this.params = this.data.params;
      // console.log(this.data.params)
      // console.log(this.data.params.body["items"])
      // console.log(this.params)
      this.datos_tabla = this.params.body["items"];
      this.puede_ser_bundle = this.params.body["puede_ser_bundle"];
      // console.log("data de tabla es")
      // console.log(this.datos_tabla)
      // this.entradaFinal = this.datos_tabla;
      // this.datos_tabla = [{}]
      this.datos_tabla = this.datos_tabla.filter((value,key)=>{
        return value;
      });
    }
  }
  breakpoint: number;
  columna1: number;
  columna2: number;
  columna3: number;
  not_found = false;
  entrada_final: [];
  ya_existe: number;
  filterName:string;
  filterCantidad: string;
  entradaDatabase: EntradaDatabaseItems | null;
  isLoadingResults = true;
  isRateLimitReached = false;
  resultsLength = 0;
  keywords = "";
  // data: object;
  dataItems: ItemsIssue[] = [];
  status_form = "reset"
  spinner = false;
  puede_ser_bundle: true;

  // MyArrayType = Array<{sku: string, producto: string, cantidad: number}>;
  entradaFinal:ProductosEntrada[] = [];
  displayedColumns = ['sku', 'producto', 'cantidad', 'action'];
  datos_tabla: ProductosEntrada[] = []



  itemForm = new FormControl('', [
    Validators.required,
  ]);

  cantidadForm = new FormControl('', [
    Validators.required,
    Validators.min(1),
  ]);


  options:[
  ];
  filteredOptions: Observable<ItemsIssue[]>;
  ngAfterViewInit() {


    this.entradaDatabase = new EntradaDatabaseItems(this._httpClient);
    // If the user changes the sort order, reset back to the first page.
    // this.hacerAutcomplete();
  }

  ngOnInit() {
    // console.log("Entro a ongit")
    this.breakpoint = (window.innerWidth <= 599) ? 1 : 6;
    this.columna1 = (window.innerWidth <= 599) ? 1 : 3;
    this.columna2 = (window.innerWidth <= 599) ? 1 : 2;
    this.columna3 = (window.innerWidth <= 599) ? 1 : 1;
    this.entradaDatabase = new EntradaDatabaseItems(this._httpClient);
    // If the user changes the sort order, reset back to the first page.
    this.hacerAutcomplete(this.keywords);
    // console.log("los items son")
    // console.log(this.dataItems)

   this.entradaFinal = this.datos_tabla;

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywords = filterValue.trim().toLowerCase();
    // console.log("las keywords son ")
    // console.log(this.keywords)
    this.hacerAutcomplete(this.keywords);
  }

  filterStates(s: any) {
    let stateName = s.seller_sku || s; // s can be a State or a string
    return this.dataItems.filter(state =>
      state.seller_sku.toLowerCase().indexOf(stateName.toLowerCase()) === 0);
  }

  hacerAutcomplete(filtros){
    merge()
    .pipe(
      startWith({}),
      switchMap(() => {
        this.isLoadingResults = true;
        return this.entradaDatabase!.getRepoIssues(filtros);
      }),
      map(data => {
        // Flip flag to show that loading has finished.
        this.isLoadingResults = false;
        this.isRateLimitReached = false;
        this.resultsLength = data.total_count;
        // console.log("vamos con los items")
        // console.log(data)
        return data.items;
      }),
      catchError(() => {
        this.isLoadingResults = false;
        // Catch if the GitHub API has reached its rate limit. Return empty data.
        this.isRateLimitReached = true;
        return observableOf([]);
      })
    ).subscribe(data => this.dataItems = data);
  }

  displayFn(subject){
    let texto = "";
    if(subject){
      if(subject.seller_sku){
        texto = subject.seller_sku + " | Cantidad Disp." + subject.available_quantity
        return texto;
      }else if(subject.title){
        texto = subject.title + " | Cantidad Disp." + subject.available_quantity
        return texto;
      }
    }else{
      return undefined;
    }

  }

  actualizarBundle(){
    // tomar this.entrada_final que seran los Component y this.item_bundle el bundle_name_item_id
    //Hacer request para hacer el bundle

    // Descomentar cuando ya se tenga el request
    
    this.inventarioService.cambiarBundle(this.entradaFinal, this.item_bundle)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("la data es");
        // console.log(data);
        // console.log(data.status)
        // console.log(data["message"]);
        this.spinner = false;
        this.snackBar.open(data["message"], "OK", {                      
          duration: 3500,
        });
      },
      error => {
        this.spinner = false;
    });


    // this.dialogRef.close();
  }

  validarDatos(){
    this.status_form = "submitted"
    if(this.itemForm.invalid || this.cantidadForm.invalid){
      return;
    }
    let elItem = this.itemForm.value;
    if(!elItem){
      return;
    }
    // console.log(this.itemForm.value);
    // console.log(elItem)
    let producto = elItem.title;
    let item_id = elItem.id;
    let el_seller_sku = elItem.seller_sku;
    let cantidad_maxima = elItem.available_quantity
    // console.log("el item_id es "+item_id)
    // console.log("typeof "+  typeof item_id)
    if(!item_id){
      this.snackBar.open("Debes agrear un producto valido", "OK", {                      
        duration: 3500,
      });
      return;
    }

    if(elItem.bundle > 0){
      this.snackBar.open(`EL SKU: ${elItem.seller_sku} es un bundle, por lo tanto, no puede agregarse como componente de otro bundle`, "OK", {                      
        duration: 3500,
      });
      return;
    }
    // if(this.cantidadForm.value > cantidad_maxima){
    //   if(cantidad_maxima == 0 && elItem.acepta_bo){

    //   }else{
    //     this.filterCantidad = "";
    //     this.snackBar.open("No puedes agregar más de la cantidad disponible", "OK", {                      
    //       duration: 3500,
    //     });
    //     return;
    //   }
    // }
    //this.status_form = "reset"
    this.filterName = null;
    this.filterCantidad = null;
    this.addItem(this.entradaFinal, el_seller_sku, this.cantidadForm.value, producto, item_id);
    // this.entradaFinal.push({sku: this.itemForm.value, producto: producto, cantidad: this.cantidadForm.value});
    // // console.log(this.entradaFinal);
    this.datos_tabla = this.entradaFinal;
    this.datos_tabla = this.datos_tabla.filter((value,key)=>{
      return value;
    });
    // console.log("La entrada_final es")
    // console.log(this.entradaFinal)
  }

  addItem(arr, seller_sku, quantity, titulo, item_id) {
    // console.log("arr es" +arr);
    let { length } = arr;
    let id = length + 1;
    let found = arr.some(el => el.sku === seller_sku);
    if (!found){
      arr.push({sku: seller_sku, producto: titulo, cantidad: quantity, item_id: item_id});
    }else{
      let index = arr.findIndex(x => x.sku === seller_sku);
      // console.log("el repetido es el " + index);
      arr[index].cantidad = arr[index].cantidad + quantity;
    }
    return arr;
  }

  onResize(event) {
    this.breakpoint = (event.target.innerWidth <= 599) ? 1 : 6;
    this.columna1 = (window.innerWidth <= 599) ? 1 : 3;
    this.columna2 = (window.innerWidth <= 599) ? 1 : 2;
    this.columna3 = (window.innerWidth <= 599) ? 1 : 1;
  }

  deleteRowData(row_obj){
    this.datos_tabla = this.datos_tabla.filter((value,key)=>{
      return value.sku != row_obj.sku;
    });
    this.entradaFinal = this.datos_tabla;
    // console.log(this.entradaFinal)
  }


  /** Gets the total cost of all datos_tabla. */
  getTotalCost() {
    return this.datos_tabla.map(t => t.cantidad).reduce((acc, value) => acc + value, 0);
  }

}

@Component({
  selector: 'productos-detalle',
  templateUrl: './productos-detalle.html',
  styleUrls: ['./productos.component.scss']

})

export class ProductosDetalle implements OnInit {

  @Output() editClicked = new EventEmitter<any>();

  item: any;
  files: any;
  inventario_scrap: any;
  spinner = false;
  current_user: any;

  constructor(public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private _httpClient: HttpClient,
    public dialogRef: MatDialogRef<ProductosDetalle>,
    private inventarioService: InventarioService,
    private productoService: ProductoService,
    private router: Router,
    private authenticationService: AuthenticationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    if(this.data){
      this.item = this.data.item;
      this.files = this.data.files;
      this.inventario_scrap = this.data.inventario_scrap;
    }
  }

  ngOnInit() {
    this.asignarDatos(); 
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue
    
  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);  
  }

  showEtiqueta(item_id, seller_sku){
    if(seller_sku != ""){
      this.spinner = true
      this.inventarioService.getEtiqueta(item_id, seller_sku)
      .pipe(first())
      .subscribe(
        data => {
          console.log(data)
          if(data.status == 200){
            if(data.body["se_puede"] == true){
              window.open(data.body["status"], "_blank");
              this.spinner = false
            }else{
              this.snackBar.open("El producto debe tener un SKU menor o igual a 15 caracteres.", "OK", {                      
                duration: 5000,
              });
              this.spinner = false
            }
          }else{
            this.snackBar.open("Ocurrio un error al generar la etiqueta", "OK", {                      
              duration: 5000,
            });
            this.spinner = false
          }
        },
        error => {
      });
    }else{
      this.snackBar.open("El producto debe tener un SKU menor o igual a 15 caracteres.", "OK", {                      
        duration: 5000,
      });
    }
  }

  editarPorducto(item_id){
    this.editClicked.emit(item_id);
    this.dialogRef.close();
  }

  confirmarEliminarProducto(item_id){
    const dialogRef1 = this.dialog.open(ProductosDialog1, {width:'450px', height: 'auto',disableClose: true});

    dialogRef1.afterClosed().subscribe(result => {
      if (result == true){
        this.eliminarPorducto(item_id);
      }
    });
  }

  eliminarPorducto(item_id){
    this.spinner = true;
      this.productoService.eliminarPorducto(item_id)
      .pipe(first())
      .subscribe(
        data => {
          if (data["status"] == 200){
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/productos']);
            });
          }
          this.snackBar.open(data["message"], "OK", {                      
            duration: 7500,
          });
         this.spinner = false;
         this.dialogRef.close();
        },
        error => {
          this.spinner = false;
          this.snackBar.open("Hubo un error al eliminar el producto", "OK", {                      
            duration: 7500,
          });
     });
  }

  openDialogEntrada(item_id, seller_sku, titulo){
    // Hacer request para consular el bundle y que responda como
    // render {items => los componentes del bundle que venga (sku, producto, cantidad) }
    // DESCOMENTAR CUANDO ESTE EL REUQEST LISTO
    this.inventarioService.consultarBundle(item_id)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("consultar Bundle es");
        // console.log(data);
        if(data.status == 200){
          const dialogRef3 = this.dialog.open(ProductosDialogBundle ,{ width:'90vw', height: '90%',disableClose: false ,data: {params: data, seller_sku: seller_sku, titulo: titulo, item_id: item_id} });
        }
      },
      error => {
    });

    // Quitar cuando ya se tenga el request
    // let data = {items: []} // Comentar cuando ya se tenga el request
    // const dialogRef3 = this.dialog.open(ProductosDialogBundle ,{ width:'90vw', height: '90%',disableClose: false ,data: {params: data, seller_sku: seller_sku, titulo: titulo, item_id: item_id} });
  }

}

@Component({
  selector: 'productos-dialog-1',
  templateUrl: './productos-dialog-1.html',
})
export class ProductosDialog1 {}

export interface EntradaIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
  seller_sku: string;
  ean: string;
}

export class EntradaDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number, filtro: string): Observable<EntradabApi> {
     const href = `${environment.apiUrl}/items.json`;
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}&nombre_producto=${filtro}`;

    return this._httpClient.get<EntradabApi>(requestUrl);
  }
}

export class EntradaDatabaseItems {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(filtro: string): Observable<EntradabApi2> {
    const href = `${environment.apiUrl}/rmsfe/listar_items.json`;
    const requestUrl = `${href}?nombre_producto=${filtro}`;
    return this._httpClient.get<EntradabApi2>(requestUrl);
  }
}

export interface ItemsIssue {
  id: number;
  seller_sku: string;
  title: string;
  available_quantity: number;
}

export interface ProductosEntrada {
  sku: string;
  producto: string;
  cantidad: number;
}

export interface EntradabApi2 {
  items: ItemsIssue[];
  total_count: number;
}

export interface EntradabApi {
  items: EntradaIssue[];
  total_count: number;
}

export interface ClaveSat {
  clave_prod_serv: string;
  descripcion: string;
  palabras_similares: string;
  material_peligroso: string;
  fecha_inicio_vigencia: string;
  fecha_fin_vigencia: string;
  created_at: string;
}